export default __webpack_public_path__ + "static/media/button_d.045cd270.png";